import { presentNewListingPrompt } from 'app/atoms';
import { useTrackNewListingSource } from 'app/network/listing';
import type { ListingType, NewListingSource } from 'app/types/listing';
import { useAtom } from 'jotai';

export const useNewListingPrompt = () => {
  const trackNewListingSource = useTrackNewListingSource();

  const newListingPromptState = useAtom(presentNewListingPrompt);
  const [, setIsNewListingPromptVisible] = newListingPromptState;

  const showNewListingPrompt = (source: NewListingSource, listingType?: ListingType) => {
    trackNewListingSource(source);
    setIsNewListingPromptVisible(listingType ?? true);
  };

  const hideNewListingPrompt = () => {
    setIsNewListingPromptVisible(false);
  };

  const showNewPostPrompt = () => {
    setIsNewListingPromptVisible('post');
  };

  return { showNewListingPrompt, showNewPostPrompt, hideNewListingPrompt, newListingPromptState };
};
